import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ page, sort, size, zone, resources }) =>
    present(
      repository
        .getGantt(sort, page, size, zone, resources)
        .then((gantt) => ({ page, sort, size, gantt, zone, resources }))
        .catch(() => Promise.reject({ page, sort, size, zone, resources })),
    );
}

export type { Interactor };

export { createInteractor };
